import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const Cardssection = () => {
  const { t } = useTranslation();

  const cardsData = [
    {
      id: 1,
      iconSrc: "../../assets/icons/microphone.svg",
      title: t("features.cards.one.title"),
      points: t("features.cards.one.points"),
      imageSrc: "../../assets/images/features/voicecmd.png",
      reverse: false,
    },
    {
      id: 2,
      iconSrc: "../../assets/icons/file.png",
      title: t("features.cards.two.title"),
      points: t("features.cards.two.points"),
      imageSrc: "../../assets/images/features/aidrivencase.png",
      reverse: true,
    },
    {
      id: 3,
      iconSrc: "../../assets/icons/bot.svg",
      title: t("features.cards.three.title"),
      points: t("features.cards.three.points"),
      imageSrc: "../../assets/images/features/legalbotboard.png",
      reverse: false,
    },
    {
      id: 4,
      iconSrc: "../../assets/icons/settings.svg",
      title: t("features.cards.four.title"),
      points: t("features.cards.four.points"),
      imageSrc: "../../assets/images/features/taskautomboard.png",
      reverse: true,
    },
    {
      id: 5,
      iconSrc: "../../assets/icons/search.svg",
      title: t("features.cards.five.title"),
      points: t("features.cards.five.points"),
      imageSrc: "../../assets/images/features/contractreviewboard.png",
      reverse: false,
    },
    {
      id: 6,
      iconSrc: "../../assets/icons/language.svg",
      title: t("features.cards.six.title"),
      points: t("features.cards.six.points"),
      imageSrc: "../../assets/images/features/multilingualboard.png",
      reverse: true,
    },
  ];

  useEffect(() => {
    // Get stored service ID
    const serviceId = sessionStorage.getItem("selectedService");

    if (serviceId) {
      // Clear session storage after use
      sessionStorage.removeItem("selectedService");

      // Delay scrolling slightly to ensure the page is fully loaded
      setTimeout(() => {
        const element = document.getElementById(`service-${serviceId}`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300); // Adjust delay if needed
    }
  }, []);

  return (
    <div className="cards-main z-[3] relative w-100 bg-white rounded-[38px] mt-[-60px] max-sm:mt-[80px] pt-[90px] pb-[205px]">
      <div className="cards-inner-wrapper max-w-[80%] max-xxxl:max-w-[90%] m-auto flex flex-col gap-[80px]">
        {cardsData.map((card) => (
          <div
            key={card.id}
            id={`service-${card.id}`} // Set ID for scrolling
            className={`flex items-center gap-[152px] justify-center max-sm:flex-col max-sm:gap-[12px] ${
              card.reverse ? "flex-row-reverse" : ""
            }`}
          >
            <div className="left-section flex flex-col gap-[22px] w-[50%] max-sm:w-[100%]">
              <img
                src={card.iconSrc}
                alt={`${card.title} icon`}
                className="w-[63px] h-[63px]"
              />
              <h2 className="heading-color tracking-[-3px] leading-[60px] font-sora max-w-[504px]">
                {card.title}
              </h2>
              <ul className="list-disc pl-5">
                {card.points.map((point, i) => (
                  <li
                    key={i}
                    className="arge max-w-[504px] leading-[35px] txt-color font-medium"
                  >
                    {point}
                  </li>
                ))}
              </ul>
            </div>
            <div className="w-[50%] max-sm:w-[100%]">
              <img
                src={card.imageSrc}
                alt={`${card.title} visual`}
                className="w-100 h-100"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Cardssection;
